import { Box, Typography, MediaFlex } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"

import { to_currency } from "helpers/number"

import { KlarnaTitle, TextLink, Question } from "./components"
import FAQCarousel from "./faq-carousel"

const country = () => sl.config.site_country_for_analytics.toLowerCase()
const customerServiceLink = () =>
  `https://www.klarna.com/${sl.config.site_country}/customer-service/`
const faqLink = () =>
  `https://www.klarna.com/${sl.config.site_country}/customer-service/csc/payments/`
const termsLinkPrefix = () =>
  `https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_${country()}`

const FaqPayIn3 = () => {
  const questions = [
    <>
      <Question>How does “Pay in 3” work?</Question>
      <Typography mb={2}>
        “Pay in 3” allows you to spread any purchase between{" "}
        {to_currency(sl.config.klarna_min)} and{" "}
        {to_currency(sl.config.klarna_max)} over 3 payments. Your first payment
        is taken when your order is shipped, and the next 2 payments will be
        automatically charged to the card on file every 30 days. Scheduled
        payments cannot be changed or updated. See full{" "}
        <TextLink href={`${termsLinkPrefix()}/slice_it_card`} target="_blank">
          terms
        </TextLink>{" "}
        here.
      </Typography>
      <Typography mb={2}>
        Please note that your bank or financial institution may place a hold on
        your account for the first payment amount when order is placed.
      </Typography>
      <Typography>
        **You must be 18+ to use Klarna’s Pay in 3 instalments and Pay in 30
        days products as these are unregulated credit agreements. Borrowing more
        than you can afford or paying late may negatively impact your financial
        status and ability to obtain credit. 18+, UK residents only. Subject to
        status. Ts&Cs and late fees apply.
      </Typography>
    </>,
    <>
      <Question>What happens if I miss a payment?</Question>
      <Typography>
        If Klarna is unable to collect a scheduled payment, you may be subject
        to a late fee. You will receive an email notification from Klarna
        directly if payment has failed for whatever reason. If you need to
        update your card information,{" "}
        <TextLink href={faqLink()} target="_blank">
          click here
        </TextLink>{" "}
        for more info.
      </Typography>
    </>,
    <>
      <Question>How do I contact Klarna?</Question>
      <Typography>
        <TextLink href={customerServiceLink()} target="_blank">
          Click here
        </TextLink>{" "}
        to contact Klarna anytime for any additional questions. Please note that
        Klarna is an independent payment company and {sl.config.site_title} has
        no influence over whether payments are accepted or not.
      </Typography>
    </>,
  ]

  return (
    <Box contain mb={7} textAlign="center">
      <KlarnaTitle>FAQs</KlarnaTitle>
      <MediaFlex
        flexWrap="wrap"
        greaterThanOrEqual="tablet"
        gutter={{ tablet: 3 }}
        mb={8}
        textAlign="left"
      >
        {questions.map((q, i) => (
          <Box flex={1} key={i}>
            {q}
          </Box>
        ))}
      </MediaFlex>
      <FAQCarousel questions={questions} />
      <Link
        data-lc="faq"
        style={{ color: "black", textDecoration: "underline" }}
        to="/helpdesk"
      >
        Read more FAQs here
      </Link>
    </Box>
  )
}

const FaqPayIn4 = () => {
  const questions = [
    <>
      <Question>How does “Pay Later in 4” work?</Question>
      <Typography mb={2}>
        Pay Later in 4 allows you to spread any purchase between{" "}
        {to_currency(sl.config.klarna_min)} and{" "}
        {to_currency(sl.config.klarna_max)} over 4 payments. Your first payment
        is taken when your order is processed and the remaining 3 are
        automatically taken every 14 days. Scheduled payments cannot be changed
        or updated. See full{" "}
        <TextLink href={`${termsLinkPrefix()}/paylaterin4`} target="_blank">
          terms
        </TextLink>{" "}
        here.
      </Typography>
      <Typography>
        Please note that a higher initial payment may be required for some{" "}
        purchases.
      </Typography>
    </>,
    <>
      <Question>What happens if I miss a payment?</Question>
      <Typography>
        If Klarna is unable to collect a scheduled payment, you may be subject
        to a late fee. You will receive an email notification from Klarna
        directly if payment has failed for whatever reason. If you need to
        update your card information,{" "}
        <TextLink href={faqLink()} target="_blank">
          click here
        </TextLink>{" "}
        for more info.
      </Typography>
    </>,
    <>
      <Question>How do I contact Klarna?</Question>
      <Typography>
        <TextLink href={customerServiceLink()} target="_blank">
          Click here
        </TextLink>{" "}
        to contact Klarna anytime for any additional questions. Please note that
        Klarna is an independent payment company and {sl.config.site_title} has
        no influence over whether payments are accepted or not.
      </Typography>
    </>,
  ]

  return (
    <Box contain mb={7} textAlign="center">
      <KlarnaTitle>FAQs</KlarnaTitle>
      <MediaFlex
        flexWrap="wrap"
        greaterThanOrEqual="tablet"
        gutter={{ tablet: 3 }}
        mb={8}
        textAlign="left"
      >
        {questions.map((q, i) => (
          <Box flex={1} key={i}>
            {q}
          </Box>
        ))}
      </MediaFlex>
      <FAQCarousel questions={questions} />
      <Link
        data-lc="faq"
        style={{ color: "black", textDecoration: "underline" }}
        to="/helpdesk"
      >
        Read more FAQs here
      </Link>
    </Box>
  )
}

const Faq = ({ payIn4 }) => {
  return payIn4 ? <FaqPayIn4 /> : <FaqPayIn3 />
}

Faq.propTypes = {
  payIn4: PropTypes.bool,
}

export default Faq
